import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconsModule } from '@progress/kendo-angular-icons';
import { UnityRouteUrlTrees } from '@unity/utils/types';

export type LinkVariant = 'boldblue' | 'button' | 'inline' | 'centered';

@Component({
  selector: 'unity-link-shared',
  standalone: true,
  imports: [RouterLink, NgTemplateOutlet, IconsModule],
  templateUrl: './link-shared.component.html',
  styleUrl: './link-shared.component.scss',
})
export class LinkSharedComponent {
  @HostBinding('class.boldblue') protected get isBoldBlue() {
    return this.$variants().includes('boldblue');
  }

  @HostBinding('class.centered') protected get isCentered() {
    return this.$variants().includes('centered');
  }

  @HostBinding('class.button') protected get isButton() {
    return this.$variants().includes('button');
  }

  @HostBinding('class.inline') protected get isInline() {
    return this.$variants().includes('inline');
  }

  public readonly $displayText = input.required<string>({ alias: 'displayText' });
  public readonly $link = input.required<UnityRouteUrlTrees>({ alias: 'link' });
  public readonly $variants = input.required<LinkVariant[]>({ alias: 'variants' });

  public readonly $isHref = input<boolean>(false, { alias: 'isHref' });
}
